'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function hyphenate(str) {
  return str.replace(/\B([A-Z])/g, "-$1").toLowerCase();
}
function isPromise(obj) {
  return obj instanceof Promise || obj && typeof obj.then === "function";
}
function MagicEmit(event, options = {}) {
  return function MagicEmitter(target, key, descriptor) {
    const eventName = event || hyphenate(key);
    const originalHandler = descriptor.value;
    descriptor.value = function emitter(...args) {
      if (!args[0] && !(args[0] instanceof Event)) {
        console.warn("[MagicEmit] First argument should be an event");
        return;
      }
      const originalEvent = args[0];
      const eventTarget = originalEvent.target;
      const isOwnEvent = this.$el === eventTarget && originalEvent.detail;
      const { shadowRoot } = this.$root.$options;
      const isLight = !shadowRoot || shadowRoot instanceof HTMLHeadElement;
      if (!options.noStop && !isOwnEvent) {
        originalEvent.stopPropagation();
      }
      if (!options.noPrevent && !isOwnEvent) {
        originalEvent.preventDefault();
      }
      const emit = (returnVal) => {
        if (returnVal !== void 0) {
          args.unshift(returnVal);
        }
        if (isLight) {
          if (isOwnEvent) {
            return;
          }
          const customEvent = new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: [...args]
          });
          this.$el.dispatchEvent(customEvent);
        } else {
          this.$emit(eventName, ...args);
        }
      };
      const returnValue = originalHandler.apply(this, args);
      if (isPromise(returnValue)) {
        returnValue.then((promiseValue) => {
          emit(promiseValue);
        });
      } else {
        emit(returnValue);
      }
      return returnValue;
    };
  };
}

exports.MagicEmit = MagicEmit;
